import React, { useEffect, useState } from "react";
import { RiAdminFill } from "react-icons/ri";
import { Avatar, AvatarImage } from "../../components/ui";
import { FiUsers } from "react-icons/fi";
import { BiLogIn } from "react-icons/bi";
import { FaPlus } from "react-icons/fa";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import { Header } from "../../components/modules";
import { FaTimesCircle, FaCheckCircle } from "react-icons/fa";
import Context from "../../Context";
import { MdPersonSearch } from "react-icons/md";
import { Spinner } from "reactstrap";
import { FiFileText } from "react-icons/fi";
import { getAdminOrderUrl } from "../../constants";

export const ReportRounddateNewUser = () => {
  const { callApi, configs } = Context();
  const [users, setUsers] = useState([]);
  const [roundDate, setRoundDate] = useState(configs.roundDate);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getUsers();
  }, [roundDate]);

  const getUsers = async () => {
    setLoading(true);
    const result = await callApi(
      "users-getAll",
      {
        queries: [["createdAtRound", roundDate]],
        limit: 10000,
        orderBy: ["createdAt", "desc"],
      },
      {
        notShowLoading: true,
      }
    );
    setUsers(result);
    setLoading(false);
  };

  return (
    <div className="h-fit min-w-[1200px] w-full">
      {/* header */}
      <Header
        header="Report"
        subHeader="รายงานคผู้ใช้ใหม่รายงวด"
        icon={<FiFileText className="text-blue" />}
      />
      <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-[#E5E7E9] overflow-hidden">
        <div className="flex bg-white items-center gap-4 p-3 border-b border-[#E5E7E9]">
          <p className="font-semibold text-xl">งวด</p>
          <div className="flex items-center gap-2">
            <select
              className="border-1 w-full border-gray-300 py-[5px] px-2 font-semibold rounded-lg placeholder:text-sm disabled:opacity-40"
              type="text"
              value={roundDate}
              onChange={(e) => setRoundDate(e.target.value)}
            >
              {configs.roundDates.map((roundDate) => (
                <option ket={roundDate} value={roundDate}>
                  {roundDate}
                </option>
              ))}
            </select>
            <button
              disabled={loading}
              className="flex items-center min-w-8 gap-1 py-2 px-3 bg-blue text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:opacity-60"
              onClick={() => {
                getUsers();
              }}
            >
              {loading ? <Spinner className="w-3 h-3" /> : "ค้นหา"}
            </button>
          </div>
        </div>

        {users && <DataTable users={users} />}
      </div>
    </div>
  );
};
const DataTable = ({ users }) => {
  const { callApi } = Context();
  const [loading, setLoading] = useState(false);
  return (
    <div>
      {loading && (
        <div className="bg-gray-50 ้ flex justify-center items-center w-full h-full absolute opacity-50 z-10">
          <Spinner className="w-4 h-4 font-bold" />
        </div>
      )}

      <Table className={`relative`}>
        <TableHeader className={`bg-[#f2f3f5]`}>
          <TableRow>
            <TableHead>วัน-เวลาที่สมัคร</TableHead>
            <TableHead>รหัสผู้ใช้</TableHead>
            <TableHead className={`text-center`}>ยืนยันตัวตนแล้ว</TableHead>
            <TableHead className="flex items-center gap-2">
              <RiAdminFill className="text-muted-foreground" />
              ชื่อ-นามสกุล
            </TableHead>
            <TableHead>เบอร์โทรศัพท์</TableHead>
            <TableHead></TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {users.length ? (
            users
              .sort((a, b) => {
                return b.createdAt - a.createdAt;
              })
              .map((user) => {
                return (
                  <TableRow key={user.phone}>
                    <TableCell>
                      {(user.createdAt
                        ? new Date(user.createdAt)
                        : new Date(user.registDate).getTime()
                      ).toLocaleDateString("th-TH", {
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                      })}{" "}
                      น.
                    </TableCell>
                    <TableCell className="font-semibold ">{user.id}</TableCell>
                    <TableCell className="font-semibold flex justify-center items-center">
                      {user.activated ? (
                        <FaCheckCircle className="text-green w-5 h-5" />
                      ) : (
                        <FaTimesCircle className="text-[#c15b78] w-5 h-5" />
                      )}
                    </TableCell>
                    <TableCell className="">
                      <div className="h-full flex items-center font-semibold gap-2">
                        <Avatar className={"w-6 h-6 duration-150"}>
                          <AvatarImage
                            src={
                              user?.profileImage ||
                              "https://github.com/shadcn.png"
                            }
                          />
                        </Avatar>
                        {user.firstName} {user.lastName} {user.role}
                      </div>
                    </TableCell>

                    <TableCell className="font-semibold">
                      {user.phone}
                    </TableCell>

                    <TableCell className="flex justify-end gap-2.5 font-medium">
                      <button
                        className="flex items-center gap-1 py-2 px-2 bg-blue text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-200 disabled:cursor-not-allowed"
                        onClick={async () => {
                          window.open(`/orders/create/${user.id}`, "_blank");
                        }}
                      >
                        {loading ? (
                          <Spinner className="w-3 h-3" />
                        ) : (
                          <div className="flex items-center gap-1">
                            <FaPlus /> สร้างคำสั่งซื้อสลาก
                          </div>
                        )}
                      </button>
                      <button
                        className="flex items-center gap-1 py-2 px-2 bg-[#4DA1A9] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-200 disabled:cursor-not-allowed"
                        onClick={async () => {
                          window.open(`/coupon/create/${user.id}`, "_blank");
                        }}
                      >
                        {loading ? (
                          <Spinner className="w-3 h-3" />
                        ) : (
                          <div className="flex items-center gap-1">
                            <FaPlus /> สร้างคำสั่งซื้อคูปอง
                          </div>
                        )}
                      </button>
                      <button
                        className="ml-6 flex items-center py-2 px-3 bg-blue text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-200 disabled:cursor-not-allowed"
                        onClick={async () => {
                          setLoading(true);
                          let reasult = await callApi("users-addAdminToken", {
                            userId: user.id,
                          });
                          window.open(getAdminOrderUrl(reasult.adminToken));

                          setLoading(false);
                        }}
                      >
                        {loading ? (
                          <Spinner className="w-3 h-3" />
                        ) : (
                          <BiLogIn />
                        )}
                      </button>

                      <button
                        className=" flex items-center py-2 px-3 bg-green text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-200 disabled:cursor-not-allowed"
                        onClick={async () => {
                          setLoading(true);
                          window.open("/user/" + user.id);
                          setLoading(false);
                        }}
                      >
                        {loading ? (
                          <Spinner className="w-3 h-3" />
                        ) : (
                          <MdPersonSearch />
                        )}
                      </button>
                    </TableCell>
                  </TableRow>
                );
              })
          ) : (
            <TableRow>
              <TableCell className="" colSpan="5">
                <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                  {loading ? (
                    <Spinner className="w-3 h-3" />
                  ) : (
                    <div>
                      <MdPersonSearch className="text-white" />
                      ไม่พบผู้ใช้งานเบอร์
                    </div>
                  )}
                </div>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};
